import React from 'react'
import { WemoloTypography } from '../../../components/Wemolo'
import type { ExecutePayload } from '../changelog'
import styles from './ExecuteDetails.module.css'

export const ExecuteDetails = ({ payload }: { payload: ExecutePayload }) => {
    if (!payload.message) return null

    return (
        <div className={styles.container}>
            <span className={styles.dot} />
            <WemoloTypography variant="label-xsmall" tag="span" className={styles.message}>
                {payload.message}
            </WemoloTypography>
        </div>
    )
}
